module.exports = __webpack_public_path__ + "img/Trond.325882f0.png";